var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSearchGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.99697 0C2.24314 0 0 2.24314 0 4.99697C0 7.75078 2.24314 9.99395 4.99697 9.99395C6.1945 9.99395 7.29427 9.5687 8.15616 8.86281L11.1397 11.8463C11.1858 11.8943 11.2409 11.9325 11.302 11.9589C11.363 11.9853 11.4286 11.9993 11.4951 12C11.5616 12.0006 11.6276 11.988 11.6891 11.9629C11.7507 11.9378 11.8066 11.9006 11.8536 11.8536C11.9006 11.8066 11.9378 11.7507 11.9629 11.6891C11.988 11.6276 12.0006 11.5616 12 11.4951C11.9993 11.4286 11.9853 11.363 11.9589 11.302C11.9325 11.2409 11.8943 11.1858 11.8463 11.1397L8.86281 8.15616C9.5687 7.29427 9.99395 6.1945 9.99395 4.99697C9.99395 2.24314 7.75078 0 4.99697 0ZM4.99697 0.999395C7.21069 0.999395 8.99458 2.78325 8.99458 4.99697C8.99458 7.21069 7.21069 8.99458 4.99697 8.99458C2.78325 8.99458 0.999395 7.21069 0.999395 4.99697C0.999395 2.78325 2.78325 0.999395 4.99697 0.999395Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearchGray);
export default __webpack_public_path__ + "static/media/icon_search_gray.801f8a3615626fdee99c38c5456e9fa9.svg";
export { ForwardRef as ReactComponent };